// Hides the Judge.me preview badge widget unless the product has 4+ reviews.
// Judge.me injects this widget itself (app embed), so it can't be gated in Liquid -
// it has to be filtered client-side once the widget renders its review count.
(function () {
  var MIN_REVIEWS = 4;

  function maybeHideBadge(badgeEl) {
    var count = parseInt(badgeEl.getAttribute('data-number-of-reviews'), 10) || 0;
    var widget = badgeEl.closest('.jdgm-widget.jdgm-preview-badge');

    if (widget && count < MIN_REVIEWS) {
      widget.style.display = 'none';
    }
  }

  function scan(root) {
    root.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]').forEach(maybeHideBadge);
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('.jdgm-prev-badge[data-number-of-reviews]')) {
          maybeHideBadge(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      });

      if (mutation.type === 'attributes' && mutation.target.matches('.jdgm-prev-badge')) {
        maybeHideBadge(mutation.target);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-number-of-reviews'],
  });
})();
